<template>
    <div>
        <!-- start page title -->
        <div class="row">
            <div class="col-12">
                <div class="page-title-box">
                    <div class="page-title-right">
                        <ol class="breadcrumb m-0">
                            <li class="breadcrumb-item">
                                <router-link :to="{ name: 'Dashboard' }">Главная</router-link>
                            </li>
                            <li class="breadcrumb-item">
                                Кэш
                            </li>
                        </ol>
                    </div>

                    <h4 class="page-title">Кэш</h4>
                </div>
            </div>
        </div>
        <!-- end page title -->

        <router-view></router-view>
    </div>
</template>

<script>
export default {
    name: 'CacheLayout',
    data: () => {
        return {

        }
    },
    methods: {
    }
};
</script>